import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { CancelButton } from "../Controls/CancelButton";
import { ConfirmButton } from "../Controls/ConfirmButton";
import Popup from "../Popup/Popup";
import QueueStyle from "../Styled/Queue.style";
import StackStyle from "../Styled/Stack.style";

export default function DuplicateDealFoundPopup({
  title,
  open,
  onClose,
  checked,
  setChecked,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <StackStyle>
          <p>Would you like to update this record or insert a duplicate?</p>
          <QueueStyle>
            <RadioGroup
              aria-labelledby="duplicate-deal-found-group"
              defaultValue="duplicate"
              name="duplicate-deal-found-radio-buttons-group"
            >
              <FormControlLabel
                value="duplicate"
                control={
                  <Radio
                    checked={checked === true}
                    onChange={() => setChecked(true)}
                    value="duplicate"
                    name="should-duplicate-deal"
                    inputProps={{ "aria-labelledby": "duplicate" }}
                  />
                }
                label="Insert"
              />
              <FormControlLabel
                value="update"
                control={
                  <Radio
                    checked={checked === false}
                    onChange={() => setChecked(false)}
                    value="update"
                    name="should-duplicate-deal"
                    inputProps={{ "aria-labelledby": "duplicate" }}
                  />
                }
                label="Update"
              />
            </RadioGroup>
          </QueueStyle>
          <QueueStyle>
            <CancelButton onClick={onClose} />
            <ConfirmButton disabled={checked === null} onClick={onConfirm} />
          </QueueStyle>
        </StackStyle>
      </DialogContent>
    </Dialog>
  );
}
